import { createClient } from "@supabase/supabase-js";

// Read from environment variables - REQUIRED for security
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Validate config - show clear error instead of silent failures
const isMissingConfig = !supabaseUrl || !supabaseAnonKey;

if (isMissingConfig) {
  console.error(
    "Missing required Supabase environment variables. " +
    "Please set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY in your .env file."
  );
}

// Create client with fallback empty strings to prevent crash during HMR reload;
// the client will fail gracefully on actual API calls if env vars are truly missing
export const supabase = createClient(supabaseUrl || "", supabaseAnonKey || "", {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: false,
  },
});

/**
 * Guard wrapper for Supabase calls - returns early error if config is missing.
 * Use this in services for critical paths where a clear error is better than silent failure.
 *
 * Usage:
 *   const configError = checkSupabaseConfig();
 *   if (configError) return configError;
 */
export const checkSupabaseConfig = () => {
  if (isMissingConfig) {
    return {
      success: false,
      error: "Supabase is not configured. Check your environment variables.",
      data: null,
    };
  }
  return null;
};

export default supabase;
